import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Organizacion } from "@/shared/types/organizacion";

export interface OrganizacionAddRequest {
    nombre: string,
}

export async function addOrganizacion(request: OrganizacionAddRequest): Promise<Organizacion> {
    await sleep(1000);
    const response = await api.post("organizaciones", request);
    return response.data;
}

export function useAddOrganizacionMutation(mutationConfig: MutationConfig<Organizacion, OrganizacionAddRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addOrganizacion,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["organizaciones"] });
        },
    })
}

export interface AddOrganizacionMutationProps {
    mutationConfig?: MutationConfig<Organizacion, OrganizacionAddRequest>
    children?: (mutationResult: MutationResult<Organizacion, OrganizacionAddRequest>) => ReactNode
}

export function AddOrganizacionMutation({
    mutationConfig,
    children
}: AddOrganizacionMutationProps) {
    const mutationResult = useAddOrganizacionMutation(mutationConfig);
    return children && children(mutationResult);
}